import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		dialogBox: {
			position: 'fixed',
			bottom: 100,
			left: 24,
			width: '400px',
			maxWidth: 'calc(100vw - 48px)',
			backgroundColor: 'white',
			borderRadius: 8,
			boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
			display: 'flex',
			flexDirection: 'column',
			zIndex: 1201,
		},
		dialogBoxSuccess: {
			backgroundColor: '#4a5568',
			maxHeight: 'auto',
		},
		dialogBoxForm: {
			maxHeight: '75vh',
		},
		successHeader: {
			padding: '16px 24px',
			display: 'flex',
			justifyContent: 'flex-end',
		},
		successCloseButton: {
			color: 'rgba(255, 255, 255, 0.5)',
		},
		successContent: {
			padding: '40px 60px',
			textAlign: 'center',
			color: 'white',
		},
		successTitle: {
			marginBottom: 24,
			fontWeight: 400,
		},
		successMessage: {
			marginBottom: 40,
		},
		successLink: {
			color: 'white',
			textDecoration: 'underline',
		},
		successCaption: {
			color: 'rgba(255, 255, 255, 0.8)',
		},
		successPostAnotherLink: {
			color: 'rgba(255, 255, 255, 0.8)',
			textDecoration: 'underline',
			cursor: 'pointer',
		},
		formHeader: {
			padding: '16px 24px',
			borderBottom: '1px solid #e0e0e0',
			display: 'flex',
			alignItems: 'center',
			position: 'relative',
		},
		headerSpacer: {
			flex: 1,
		},
		headerTitle: {
			position: 'absolute',
			left: '50%',
			transform: 'translateX(-50%)',
		},
		headerCloseButton: {
			marginLeft: 'auto',
		},
		formContent: {
			padding: '16px 24px',
			overflowY: 'auto',
			flex: 1,
		},
		optionalLabel: {
			fontWeight: 'normal',
			color: '#999',
		},
		selectPlaceholder: {
			color: '#999',
		},
		uploadBox: {
			border: '2px dashed #ccc',
			borderRadius: 8,
			padding: 32,
			textAlign: 'center',
			cursor: 'pointer',
		},
		uploadBoxActive: {
			border: '2px dashed #2B78C5',
			backgroundColor: '#f0f7ff',
		},
		uploadBoxDisabled: {
			cursor: 'default',
		},
		uploadText: {
			marginBottom: 4,
		},
		uploadTextSecondary: {
			color: '#666',
		},
		attachmentThumbnail: {
			position: 'relative',
			width: 120,
			height: 120,
			borderRadius: 8,
			overflow: 'hidden',
			backgroundColor: '#f5f5f5',
		},
		attachmentImage: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},
		removeButton: {
			position: 'absolute',
			top: 4,
			right: 4,
			backgroundColor: 'rgba(0, 0, 0, 0.6)',
			color: 'white',
			padding: 4,
		},
		addMoreBox: {
			width: 120,
			height: 120,
			border: '2px dashed teal',
			borderRadius: 8,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
		},
		addMoreBoxActive: {
			border: '2px dashed #2B78C5',
			backgroundColor: '#f0f7ff',
		},
		addMoreBoxDisabled: {
			cursor: 'default',
		},
		formFooter: {
			padding: '16px 24px',
			borderTop: '1px solid #e0e0e0',
		},
		submitButton: {
			float: 'right',
		},
		speechBubbleArrow: {
			position: 'fixed',
			bottom: 84,
			left: 40,
			width: 0,
			height: 0,
			borderLeft: '12px solid transparent',
			borderRight: '12px solid transparent',
			zIndex: 1201,
		},
		speechBubbleArrowWhite: {
			borderTop: '16px solid white',
		},
		speechBubbleArrowGray: {
			borderTop: '16px solid #4a5568',
		},
		attachmentsContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			gap: 16,
		},
		plusIcon: {
			color: 'teal',
			backgroundColor: '#f5f5f5',
			borderRadius: '50%',
			padding: 8,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		uploadIcon: {
			backgroundColor: '#f5f5f5',
			borderRadius: '50%',
			padding: 8,
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		requiredAsterisk: {
			color: 'red',
			marginLeft: 4,
		},
	} satisfies Record<string, CSSObject>);
